import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {user} from "../../../models/user";
import { empresa } from '../../../models/empresa';
import {UserService} from "../../../services/user.service";
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css']
})
export class DeleteUserComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteUserComponent>, @Inject(MAT_DIALOG_DATA) public data: {usuario: user, empresa: empresa},
              private userService: UserService, public localiser: Localiser) { }

  ngOnInit(): void {
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  deleteUser() {
    this.userService.deleteUser(this.data.usuario.idUsuario).subscribe(result => {
      this.onCancelClick();
    })
  }

}
